module.exports = __webpack_public_path__ + "media/images/markers/audio-2x-36dc713c6eb0143d78ef47f27feffe27.png";